import { render, staticRenderFns } from "./ChangeLanguageModal.vue?vue&type=template&id=8feb5508&scoped=true&"
import script from "./ChangeLanguageModal.vue?vue&type=script&lang=js&"
export * from "./ChangeLanguageModal.vue?vue&type=script&lang=js&"
import style0 from "./ChangeLanguageModal.vue?vue&type=style&index=0&id=8feb5508&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8feb5508",
  null
  
)

export default component.exports